/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ------------------------------------------------------------------------- *
 * P2 — STICKY ADD-TO-CART PAA MOBIL
 *
 * Baren ligger i sections/sticky-add-to-cart.liquid og renderes TOM. Her
 * spejles pris og knaptekst fra koebsboksen, og baren vises naar den rigtige
 * knap er scrollet op og ud af billedet.
 *
 * Fire ting i denne kode findes fordi produktsidens DOM opfoerer sig paa maader
 * der ikke er indlysende. Aendrer du noget her, laes dem foerst.
 *
 * 1. KOEBSBOKSEN FINDES TO GANGE. v7 pre-renderer quick-buy-modalen paa
 *    produktsiden, saa .product-form__add-button, .price-list og
 *    .product-form__buy-buttons optraeder hver TO gange i DOM'en. Alt herunder
 *    filtrerer modalens kopi vaek paa #quick-buy-modal-content. Uden filteret
 *    ville baren kunne komme til at spejle modalens knap.
 *
 * 2. KNAPPEN MAA ALDRIG CACHES. Ved variantskift henter v7 frisk
 *    server-renderet HTML via Section Rendering API og UDSKIFTER
 *    .product-form__payment-container. Knappen er altsaa en ny DOM-node
 *    bagefter, og en gemt reference peger paa en node der ikke laengere er i
 *    dokumentet. Derfor slaas den op paa ny ved hvert klik.
 *
 * 3. MutationObserver, IKKE variant:changed. Temaet dispatcher variant:changed
 *    FOER product:rerender bytter DOM'en, saa en lytter paa eventet ville laese
 *    den GAMLE pris. En observer paa <product-form> fanger udskiftningen
 *    uanset hvilken mekanisme der udfoerte den.
 *
 * 4. EN SCROLL-LYTTER, IKKE IntersectionObserver. Foerste udgave brugte IO og
 *    fejlede paa den maade der er sværest at opdage: IO fyrer KUN naar
 *    intersection-tilstanden aendrer sig. Ved page load ligger koebsboksen
 *    under folden (ikke-intersecting, bottom 962 i en 844px viewport), og et
 *    hurtigt fling forbi den saetter den over folden (stadig
 *    ikke-intersecting, bottom -600). Ingen taerskel blev krydset, ingen
 *    callback, ingen bar. Maalt via CDP paa en 390x844 mobil-viewport.
 *
 *    Momentum-scroll paa mobil flytter let mere end en viewporthoejde mellem
 *    to frames, saa det er ikke et kanttilfaelde. Det er den normale maade at
 *    scrolle en lang produktside paa en telefon.
 *
 *    Betingelsen er nu udelukkende geometrisk: baren vises naar koebsboksens
 *    bund er over viewportens top. Laest én gang pr. frame via rAF.
 * ------------------------------------------------------------------------- */
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var priceSlot = bar.querySelector('[data-sticky-atc-price]');
  var buttonSlot = bar.querySelector('[data-sticky-atc-button]');
  var labelSlot = bar.querySelector('[data-sticky-atc-label]');
  if (!priceSlot || !buttonSlot) return;

  // Se punkt 1: modalens kopi skal filtreres vaek.
  function firstInMainColumn(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest('#quick-buy-modal-content')) return nodes[i];
    }
    return null;
  }

  function realButton() {
    return firstInMainColumn('.product-form__add-button');
  }

  function realPriceList() {
    return firstInMainColumn('.product-info__block-item--variant-selector .price-list');
  }

  function sync() {
    var button = realButton();
    if (!button) {
      // Ingen koebsknap: kontakt-produkter og gavekort renderer et link i
      // stedet. Der er intet at spejle, saa baren bliver vaek.
      bar.hidden = true;
      return;
    }

    buttonSlot.textContent = button.textContent.trim();
    buttonSlot.disabled = button.disabled;
    buttonSlot.classList.toggle('button--disabled', button.disabled);
    buttonSlot.classList.toggle('button--primary', !button.disabled);

    var price = realPriceList();
    priceSlot.innerHTML = price ? price.innerHTML : '';

    // ÉT FELT MED ÉN REGEL: navngiv det du koeber.
    //
    // Har produktet flere varianter, er den VALGTE det mest praecise, og den
    // overskriver produktnavnet. Har det kun én, er der intet valg at
    // gengive, og produktnavnet - server-renderet i slottet - bliver staaende.
    //
    // Derfor overskrives der KUN naar der findes en valgt vaerdi. Temaet
    // renderer slet ingen variant-picker paa single-variant-produkter, saa
    // faldbacken traeder til af sig selv uden en betingelse i Liquid.
    if (labelSlot) {
      var valgte = [];
      var noder = document.querySelectorAll(
        '.product-info__block-item--variant-selector .product-form__selected-value');
      for (var i = 0; i < noder.length; i++) {
        if (noder[i].closest('#quick-buy-modal-content')) continue;
        var v = (noder[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (v) valgte.push(v);
      }
      // Flere options (fx laengde OG farve) samles med en tynd separator.
      if (valgte.length) labelSlot.textContent = valgte.join(' · ');
      labelSlot.hidden = !labelSlot.textContent.replace(/\s+/g, ' ').trim();
    }
  }

  // Se punkt 2: slaa knappen op paa ny, hver gang.
  buttonSlot.addEventListener('click', function () {
    var button = realButton();
    if (button && !button.disabled) button.click();
  });

  // Se punkt 3.
  var form = firstInMainColumn('product-form');
  if (form) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        sync();
      });
    }).observe(form, { childList: true, subtree: true });
  }

  sync();

  // Se punkt 4. Ankeret er .product-form__buy-buttons og ikke knappen selv,
  // fordi den ydre div bliver staaende ved variantskift: kun dens indre
  // .product-form__payment-container udskiftes.
  var anchor = firstInMainColumn('.product-form__buy-buttons');

  // ANDET DER KLAEBER TIL BUNDEN, OG HVORFOR VI LOEFTER OS OVER DET
  //
  // To ting laegger sig praecis dér hvor vores bar skal vaere:
  //
  //   #PBarNextFrameWrapper                Shopifys preview-bar, 68px hoej.
  //   div[class*="kl-private-reset-css"]   Klaviyos formularer.
  //
  // Preview-baren findes KUN naar temaet ses gennem et preview- eller
  // delelink. Verificeret: nul spor af den paa det publicerede tema, og
  // tema-editorens iframe har den heller ikke. Den er derfor ikke en fejl i
  // produktion — men hele godkendelsesvejen i CRO-programmet gaar gennem
  // preview-links, saa uden dette offset kan en sticky bar ikke godkendes af
  // den der skal godkende den.
  //
  // Klaviyos teaser ("10% venter paa dig her") ER en bundbar i produktion, og
  // den er den egentlige aarsag til at baren foeltes doed paa mobil.
  //
  // VI SKJULER DEN IKKE. Teaseren er en marketingflade som marketing ejer, og
  // en CSS-regel der skjuler en apps element ville haenge paa klassenavne med
  // hash-suffiks (Xuajs1), der kan skifte uden varsel. Den rene loesning er at
  // udelukke produktsider fra formularens targeting i Klaviyo-admin. Indtil da
  // stabler vi: koebsknappen oeverst, teaseren nederst, og teaseren kan lukkes.
  //
  // GEOMETRIEN GOER ARBEJDET, IKKE SELEKTOREN. Et element taeller kun som
  // hindring hvis det faktisk er en strimmel i bunden: synligt, bundkant ved
  // viewportens bund, og hoejst 40 % af skaermhoejden. Dermed udelukkes en
  // fuldskaerms-modal, hvor et offset ville vaere meningsloest, mens
  // teaserbarer og preview-baren taeller med. Skal en ny app med en bundbar
  // med, er det én selektor mere i listen.
  var HINDRINGER = '#PBarNextFrameWrapper, div[class*="kl-private-reset-css"]';

  function bundHindring() {
    var vh = window.innerHeight;
    var hoejest = 0;
    var noder = document.querySelectorAll(HINDRINGER);
    for (var i = 0; i < noder.length; i++) {
      var e = noder[i];
      if (e === bar || bar.contains(e)) continue;
      var cs = getComputedStyle(e);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (parseFloat(cs.opacity) < 0.05) continue;
      var r = e.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (r.bottom < vh - 8 || r.top > vh - 8) continue;   // klaeber den til bunden?
      if (r.height > vh * 0.4) continue;                   // fuldskaerms-modal, ikke en strimmel
      if (r.height > hoejest) hoejest = r.height;
    }
    return Math.round(hoejest);
  }

  var sidsteOffset = -1;
  function opdaterOffset() {
    var h = bundHindring();
    if (h === sidsteOffset) return;
    sidsteOffset = h;
    bar.style.bottom = h + 'px';
  }

  // Barens hoejde varierer nu: variantlinjen findes kun paa produkter med
  // flere varianter. Frem for at hardkode et tal i CSS og ramme forbi - hvad
  // der skete én gang, hvor 64px var sat mod en maalt hoejde paa 69 - maales
  // den og skrives til --sticky-atc-height, som footerens reservation bruger.
  // Vaerdien i CSS er kun et fornuftigt udgangspunkt indtil baren har vist sig
  // én gang, og den kan ikke vises uden at brugeren har scrollet forbi
  // koebsboksen, hvilket sker foer footeren naas.
  var sidsteHoejde = 0;
  function opdaterSynlighed() {
    if (!anchor || !anchor.isConnected) {
      anchor = firstInMainColumn('.product-form__buy-buttons');
      if (!anchor) return;
    }
    // Eneste betingelse: er koebsboksen scrollet op og ud af billedet?
    bar.hidden = anchor.getBoundingClientRect().bottom >= 0;

    if (!bar.hidden) {
      var h = Math.round(bar.getBoundingClientRect().height);
      if (h && h !== sidsteHoejde) {
        sidsteHoejde = h;
        document.documentElement.style.setProperty('--sticky-atc-height', h + 'px');
      }
    }
  }

  var venter = false;
  function planlaeg() {
    if (venter) return;
    venter = true;
    // Én rect-laesning pr. frame. getBoundingClientRect tvinger layout, saa
    // den maa ikke koere pr. scroll-event.
    requestAnimationFrame(function () {
      venter = false;
      opdaterSynlighed();
    });
  }

  // Offsettet holdes UDE af scroll-loekken. Det aendrer sig sjaeldent, og en
  // scanning pr. frame ville koste layout-laesninger paa flere noder mens der
  // scrolles. Synligheden er per frame; offsettet er hændelsesdrevet.
  var offsetTimer = null;
  function planlaegOffset() {
    if (offsetTimer) return;
    offsetTimer = setTimeout(function () {
      offsetTimer = null;
      opdaterOffset();
    }, 200);
  }

  window.addEventListener('scroll', planlaeg, { passive: true });
  window.addEventListener('resize', function () { planlaeg(); planlaegOffset(); }, { passive: true });
  window.addEventListener('orientationchange', function () { planlaeg(); planlaegOffset(); }, { passive: true });

  // Baade preview-baren og Klaviyos formular injiceres EFTER vores script
  // koerer, og hvis brugeren ikke scroller bagefter, fyrer intet af
  // ovenstaaende. Begge haenges paa body, saa en childList-observer dér fanger
  // dem uden at se paa hele dokumentet. Klaviyo klapper desuden sin popup
  // sammen til en teaser undervejs, hvilket aendrer hoejden.
  new MutationObserver(function () {
    planlaeg();
    planlaegOffset();
  }).observe(document.body, { childList: true, subtree: true });

  opdaterOffset();
  planlaeg();
})();
